import React from "react";
import { withTranslation } from 'react-i18next';
import { withSnackbar } from 'notistack';
import {
    Grid,
    Typography,
    Box,
    Tabs,
    Tab,
    CircularProgress
} from "@material-ui/core";
import PropTypes from 'prop-types';
import ImportDepreciationGroup from "./ImportDepreciationGroup";
import ImportChartOfAccount from "./ImportChartOfAccout";
import ImportAssets from "./ImportAssets";

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <Typography
            component="div"
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box p={1}>{children}</Box>}
        </Typography>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

class DataImport extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            selectedTab: 0
        };
    }

    handleChangeTab = (event, value) => {
        this.setState({ selectedTab: value });
    }

    render() {

        let { isLoading, selectedTab } = this.state;

        if (isLoading) {
            return (
                <div className="loading-position">
                    <CircularProgress className="spinner" color="primary" />
                </div>
            )
        }


        return <Grid container direction="row" spacing={2}>
            <Grid item container direction="column" xs={12} sm={12} md={12} lg={12} xl={12}>
                <Grid item container>
                    <Tabs value={selectedTab} variant="fullWidth" indicatorColor="secondary" onChange={this.handleChangeTab}>
                        <Tab style={{ width: '200px' }} label={this.props.t("depreciation_group")} {...a11yProps(0)} />
                        <Tab label={this.props.t("chart_of_account")} {...a11yProps(1)} />
                        <Tab label={this.props.t("assets")} {...a11yProps(2)} />
                    </Tabs>
                </Grid>
                <Grid item container className="MuiBox-rmp">
                    <TabPanel value={selectedTab} index={0} style={{ width: "100%" }}>
                        <ImportDepreciationGroup />
                    </TabPanel>
                    <TabPanel value={selectedTab} index={1} style={{ width: "100%" }}>
                        <ImportChartOfAccount />
                    </TabPanel>
                    <TabPanel value={selectedTab} index={2} style={{ width: "100%" }}>
                        <ImportAssets />
                    </TabPanel>
                </Grid>
            </Grid>
        </Grid >
    }
}

export default withSnackbar(withTranslation()(DataImport))